import Badge from "./Badge";
import Link from "next/link";
import React from "react";

interface Props {
  id: string;
  date: string;
  title: string;
  tags: string[];
}

const ExampleSOPCard = ({ id, date, title, tags }: Props) => {
  return (
    <>
      <Link
        href={`/sop-templates/${id}`}
        className="w-full h-full max-w-sm rounded-xl bg-gradient-to-r from-pink-300 via-blue-500 to-purple-600 p-0.5 shadow-md transition hover:-translate-y-1 hover:shadow-xl"
      >
        <div className="rounded-[10px] h-full bg-white p-4 !pt-20 sm:p-6">
          <time dateTime="2022-10-10" className="block text-xs text-gray-500">
            {new Date(date).toDateString().split(" ").slice(1).join(" ")}
          </time>
          <h3 className="mt-0.5 text-lg font-medium text-gray-900">{title}</h3>

          <div className="pt-4 mt-auto flex flex-wrap gap-1">
            {tags?.map((item, key) => {
              return <Badge key={key} value={item} />;
            })}
          </div>
        </div>
      </Link>
    </>
  );
};

export default ExampleSOPCard;
